import type { ReactElement } from 'react'

import { LinkButton } from './LinkButton'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { AHeading } from '@/components/enlayouts/Ir/Heading'
import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'
// import { ZenkakuSpace } from '@/components/enpages/Legal/TextStyle'

export const MailPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="IR Mail"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <AHeading>Subscribe IR News Mail</AHeading>
      <Paragraph>
        We will send timely disclosure information, legal disclosure information, etc. to those who have subscribed to our 
        IR News Mail.<br/>
        We use the e-mail delivery service provided by Magical Pocket Corporation. <br/>
        *The site beyond this point is the site of the company&apos;s IR News Mail Service.
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 50 }} />
      <LinkButton url="https://www.magicalir.net/141A/irmail_en/index.php">
        Subscribe
      </LinkButton>
      <Spacer h={{ sp: 70, pc: 100 }} />
      <AHeading>Unsubscribe IR News Mail</AHeading>
      <Paragraph>
        If you wish to unsubscribe from IR News Mail, please click the banner below.<br/>
        After your application, you will receive an email with instructions on how to proceed.<br/>
        If you wish to change your email address, please unsubscribe and then re-register a new email address.
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 50 }} />
      <LinkButton url="https://www.magicalir.net/141A/irmail_en/stopmail.php">
        Unsubscribe
      </LinkButton>
    </Layout>
  )
}

MailPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir/' },
    { name: 'IR Mail', path: '' },
  ]

  return (
    <>
      <Head
        title="IR Mail"
        description="How to apply for and stop IR email distribution."
        ogp={{ url: 'en/ir/mail' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
